/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1BatchAllocationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ORDERS_V1_BATCH_ALLOCATION_EVENT_ENTITY_NAME = 'ixc.orders.v1.BatchAllocationEvent';
export const ixcOrdersV1BatchAllocationEventEntity = new schema.Entity<IxcOrdersV1BatchAllocationEvent>(IXC_ORDERS_V1_BATCH_ALLOCATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcOrdersV1BatchAllocationEvent) => `${entity.metadata?.eventId}` });

